// import React, { useState, useEffect } from 'react';
// import {
//   getParties,
//   createParty,
//   updateParty,
//   deleteParty
// } from '../Services/Services';
// import {
//   Table,
//   Input,
//   Button,
//   Modal,
//   Form,
//   Space,
//   message,
//   Popconfirm,
//   Typography,
//   Row,
//   Col,
//   theme,
//   Tooltip
// } from 'antd';
// import {
//   SearchOutlined,
//   PlusOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   PhoneOutlined,
//   MailOutlined,
//   UserOutlined,
//   ApartmentOutlined,
//   CalendarOutlined,
//   ClockCircleOutlined,
//   WhatsAppOutlined
// } from '@ant-design/icons';

// const { Title, Text } = Typography;
// const { TextArea } = Input;

// const PartyManagement = () => {
//   const [parties, setParties] = useState([]);
//   const [filteredParties, setFilteredParties] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [editingParty, setEditingParty] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [form] = Form.useForm();
//   const { token } = theme.useToken();

//   const initialFormState = {
//     date: new Date().toISOString().split('T')[0],
//     partyName: '',
//     companyName: '',
//     mobileNumber: '',
//     whatsappNumber: '',
//     address: '',
//     email: ''
//   };

//   useEffect(() => {
//     loadParties();
//   }, []);

//   useEffect(() => {
//     if (searchTerm.trim() === '') {
//       setFilteredParties(parties);
//     } else {
//       const filtered = parties.filter(party =>
//         party.partyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         (party.companyName && party.companyName.toLowerCase().includes(searchTerm.toLowerCase())) ||
//         party.mobileNumber.includes(searchTerm) ||
//         (party.whatsappNumber && party.whatsappNumber.includes(searchTerm))
//       );
//       setFilteredParties(filtered);
//     }
//   }, [searchTerm, parties]);

//   const loadParties = async () => {
//     setLoading(true);
//     const data = await getParties();
//     if (data) {
//       setParties(data);
//       setFilteredParties(data);
//     }
//     setLoading(false);
//   };

//   const resetForm = () => {
//     form.resetFields();
//     setEditingParty(null);
//   };

//   const openModal = (party = null) => {
//     if (party) {
//       setEditingParty(party);
//       const editData = {
//         date: party.date,
//         partyName: party.partyName,
//         companyName: party.companyName || '',
//         mobileNumber: party.mobileNumber,
//         whatsappNumber: party.whatsappNumber || '',
//         address: party.address || '',
//         email: party.email || ''
//       };
//       form.setFieldsValue(editData);
//     } else {
//       form.setFieldsValue(initialFormState);
//     }
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     resetForm();
//   };

//   const handleEdit = (party) => {
//     openModal(party);
//   };

//   const handleDelete = async (id, partyName) => {
//     setLoading(true);
//     const success = await deleteParty(id);
//     if (success) {
//       message.success(`${partyName} deleted successfully`);
//       await loadParties();
//     }
//     setLoading(false);
//   };

//   const handleSubmit = async () => {
//     try {
//       const values = await form.validateFields();
//       setLoading(true);

//       let result;
//       if (editingParty) {
//         result = await updateParty(editingParty.id, values);
//         if (result) message.success('Party updated successfully');
//       } else {
//         result = await createParty(values);
//         if (result) message.success('Party created successfully');
//       }

//       if (result) {
//         resetForm();
//         await loadParties();
//         closeModal();
//       }

//       setLoading(false);
//     } catch (error) {
//       console.log('Validation failed:', error);
//       setLoading(false);
//     }
//   };

//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   // Custom row className for alternate colors
//   const getRowClassName = (_, index) => {
//     return index % 2 === 0 ? 'even-row' : 'odd-row';
//   };

//   // Compact, single-line columns with sticky SR NO and Actions
//   const columns = [
//     {
//       title: 'SR NO.',
//       key: 'srno',
//       width: 70,
//       fixed: 'left',
//       align: 'center',
//       render: (_, __, index) => (
//         <Text style={{ fontWeight: 500, color: token.colorPrimary }}>
//           {index + 1}
//         </Text>
//       )
//     },
//     {
//       title: 'Date',
//       dataIndex: 'date',
//       key: 'date',
//       width: 110,
//       render: (date) => (
//         <Space size={4}>
//           <CalendarOutlined style={{ fontSize: 12, color: token.colorTextSecondary }} />
//           <Text style={{ fontSize: 13 }}>{date}</Text>
//         </Space>
//       )
//     },
//     {
//       title: 'Party Name',
//       dataIndex: 'partyName',
//       key: 'partyName',
//       width: 160,
//       ellipsis: true,
//       render: (text) => (
//         <Space size={6}>
//           <UserOutlined style={{ color: token.colorPrimary, fontSize: 13 }} />
//           <Text strong style={{ fontSize: 13 }}>
//             {text}
//           </Text>
//         </Space>
//       )
//     },
//     {
//       title: 'Company',
//       dataIndex: 'companyName',
//       key: 'companyName',
//       width: 150,
//       ellipsis: true,
//       render: (text) => text ? (
//         <Space size={4}>
//           <ApartmentOutlined style={{ fontSize: 12, color: token.colorTextSecondary }} />
//           <Text style={{ fontSize: 13 }}>{text}</Text>
//         </Space>
//       ) : <Text type="secondary" style={{ fontSize: 12 }}>—</Text>
//     },
//     {
//       title: 'Mobile',
//       dataIndex: 'mobileNumber',
//       key: 'mobileNumber',
//       width: 130,
//       render: (text) => (
//         <Space size={4}>
//           <PhoneOutlined style={{ color: token.colorSuccess, fontSize: 12 }} />
//           <Text style={{ fontSize: 13 }}>{text}</Text>
//         </Space>
//       )
//     },
//     {
//       title: 'WhatsApp',
//       dataIndex: 'whatsappNumber',
//       key: 'whatsappNumber',
//       width: 130,
//       render: (text) => text ? (
//         <Space size={4}>
//           <WhatsAppOutlined style={{ color: '#25D366', fontSize: 13 }} />
//           <Text style={{ fontSize: 13 }}>{text}</Text>
//         </Space>
//       ) : <Text type="secondary" style={{ fontSize: 12 }}>—</Text>
//     },
//     {
//       title: 'Email',
//       dataIndex: 'email',
//       key: 'email',
//       width: 180,
//       ellipsis: true,
//       render: (text) => text ? (
//         <Space size={4}>
//           <MailOutlined style={{ fontSize: 12, color: token.colorWarning }} />
//           <Text style={{ fontSize: 13 }}>{text}</Text>
//         </Space>
//       ) : <Text type="secondary" style={{ fontSize: 12 }}>—</Text>
//     },
//     {
//       title: 'Created',
//       dataIndex: 'created_at',
//       key: 'created_at',
//       width: 110,
//       render: (date) => (
//         <Space size={4}>
//           <ClockCircleOutlined style={{ fontSize: 12, color: token.colorTextSecondary }} />
//           <Text style={{ fontSize: 13 }}>
//             {date ? new Date(date).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '-'}
//           </Text>
//         </Space>
//       )
//     },
//     {
//       title: 'Actions',
//       key: 'actions',
//       width: 100,
//       fixed: 'right',
//       align: 'center',
//       render: (_, record) => (
//         <Space size="small">
//           <Tooltip title="Edit">
//             <Button
//               type="text"
//               size="small"
//               icon={<EditOutlined />}
//               onClick={() => handleEdit(record)}
//               style={{ color: token.colorPrimary }}
//             />
//           </Tooltip>
//           <Popconfirm
//             title="Delete Party"
//             description={`Delete ${record.partyName}?`}
//             onConfirm={() => handleDelete(record.id, record.partyName)}
//             okText="Yes"
//             cancelText="No"
//             placement="topRight"
//           >
//             <Tooltip title="Delete">
//               <Button
//                 type="text"
//                 size="small"
//                 danger
//                 icon={<DeleteOutlined />}
//               />
//             </Tooltip>
//           </Popconfirm>
//         </Space>
//       )
//     }
//   ];

//   return (
//     <div style={{ minHeight: '100vh', background: token.colorBgContainer }}>
//       {/* Header Bar - Single Line */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: 20,
//         flexWrap: 'wrap',
//         gap: 12
//       }}>
//         <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
//           <Title level={4} style={{ margin: 0, fontWeight: 500 }}>
//             Party Ledger
//           </Title>
//           <Text type="secondary" style={{ fontSize: 13 }}>
//             {filteredParties.length} parties
//           </Text>
//         </div>

//         <Space size="middle">
//           <Input
//             placeholder="Search by name, company, mobile or whatsapp..."
//             prefix={<SearchOutlined style={{ color: token.colorTextSecondary }} />}
//             onChange={handleSearch}
//             style={{ width: 320 }}
//             allowClear
//             size="middle"
//           />
//           <Button
//             type="primary"
//             icon={<PlusOutlined />}
//             onClick={() => openModal()}
//           >
//             Add Party
//           </Button>
//         </Space>
//       </div>

//       {/* Table - Compact, Single Line Display with Sticky SR NO & Alternate Row Colors */}
//       <Table
//         columns={columns}
//         dataSource={filteredParties}
//         rowKey="id"
//         loading={loading}
//         size="middle"
//         rowClassName={getRowClassName}
//         pagination={{
//           pageSize: 10,
//           showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
//           showSizeChanger: true,
//           showQuickJumper: true,
//           size: 'default'
//         }}
//         scroll={{ x: 'max-content' }}
//         style={{
//           borderRadius: 8,
//           overflow: 'hidden',
//           border: `1px solid ${token.colorBorderSecondary}`
//         }}
//       />

//       {/* Modal - Description removed */}
//       <Modal
//         title={
//           <Space>
//             {editingParty ? <EditOutlined /> : <PlusOutlined />}
//             <span>{editingParty ? 'Edit Party' : 'Add New Party'}</span>
//           </Space>
//         }
//         open={isModalOpen}
//         onCancel={closeModal}
//         width={560}
//         footer={[
//           <Button key="cancel" onClick={closeModal}>
//             Cancel
//           </Button>,
//           <Button
//             key="submit"
//             type="primary"
//             loading={loading}
//             onClick={handleSubmit}
//           >
//             {editingParty ? 'Update' : 'Save'}
//           </Button>
//         ]}
//       >
//         <Form
//           form={form}
//           layout="vertical"
//           initialValues={initialFormState}
//           size="middle"
//         >
//           <Row gutter={16}>
//             <Col span={12}>
//               <Form.Item
//                 name="date"
//                 label="Date"
//                 rules={[{ required: true, message: 'Required' }]}
//               >
//                 <Input type="date" />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="partyName"
//                 label="Party Name"
//                 rules={[{ required: true, message: 'Required' }]}
//               >
//                 <Input placeholder="Enter party name" />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="companyName"
//                 label="Company Name"
//               >
//                 <Input placeholder="Enter company name" />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="mobileNumber"
//                 label="Mobile Number"
//                 rules={[{ required: true, message: 'Required' }]}
//               >
//                 <Input placeholder="Enter mobile number" />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="whatsappNumber"
//                 label="WhatsApp Number"
//               >
//                 <Input placeholder="Enter WhatsApp number" />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="email"
//                 label="Email"
//                 rules={[{ type: 'email', message: 'Invalid email' }]}
//               >
//                 <Input placeholder="Enter email address" />
//               </Form.Item>
//             </Col>
//             <Col span={24}>
//               <Form.Item
//                 name="address"
//                 label="Address"
//               >
//                 <TextArea rows={2} placeholder="Enter address" />
//               </Form.Item>
//             </Col>
//           </Row>
//         </Form>
//       </Modal>

//       {/* Styles for alternate row colors and sticky columns */}
//       <style jsx>{`
//         :global(.compact-table-row td) {
//           padding: 10px 12px !important;
//           line-height: 1.4 !important;
//         }
//         :global(.compact-table-row .ant-table-cell) {
//           white-space: nowrap !important;
//         }
//         :global(.ant-table-thead > tr > th) {
//           padding: 12px 12px !important;
//           background: ${token.colorBgLayout};
//           font-weight: 500;
//           font-size: 13px;
//         }

//         /* Alternate row colors */
//         :global(.even-row) {
//           background-color: #ffffff !important;
//         }
//         :global(.odd-row) {
//           background-color: #f5f5f5 !important;
//         }

//         /* Ensure sticky columns have proper background matching row colors */
//         :global(.even-row .ant-table-cell-fix-left),
//         :global(.even-row .ant-table-cell-fix-right) {
//           background-color: #ffffff !important;
//         }
//         :global(.odd-row .ant-table-cell-fix-left),
//         :global(.odd-row .ant-table-cell-fix-right) {
//           background-color: #f5f5f5 !important;
//         }

//         /* Header sticky columns background */
//         :global(.ant-table-thead .ant-table-cell-fix-left),
//         :global(.ant-table-thead .ant-table-cell-fix-right) {
//           background: ${token.colorBgLayout} !important;
//         }

//         /* Hover effect on rows */
//         :global(.even-row:hover),
//         :global(.odd-row:hover) {
//           background-color: #e6f7ff !important;
//         }
//         :global(.even-row:hover .ant-table-cell-fix-left),
//         :global(.even-row:hover .ant-table-cell-fix-right),
//         :global(.odd-row:hover .ant-table-cell-fix-left),
//         :global(.odd-row:hover .ant-table-cell-fix-right) {
//           background-color: #e6f7ff !important;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default PartyManagement;


import React, { useState, useEffect } from 'react';
import {
  getParties,
  createParty,
  updateParty,
  deleteParty
} from '../Services/Services';
import {
  Table,
  Input,
  Button,
  Modal,
  Form,
  Space,
  message,
  Popconfirm,
  Typography,
  Row,
  Col,
  theme,
  Tooltip,
  Grid,
  Collapse,
  Pagination,
  Card,
  Divider
} from 'antd';
import {
  SearchOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  PhoneOutlined,
  MailOutlined,
  UserOutlined,
  ApartmentOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  WhatsAppOutlined,
  RightOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;
const { TextArea } = Input;
const { useBreakpoint } = Grid;
const { Panel } = Collapse;

const PartyManagement = () => {
  const screens = useBreakpoint();
  const isMobile = screens.xs; // true for extra small screens

  const [parties, setParties] = useState([]);
  const [filteredParties, setFilteredParties] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [editingParty, setEditingParty] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const { token } = theme.useToken();

  // Pagination state for mobile view
  const [mobilePage, setMobilePage] = useState(1);
  const mobilePageSize = 5;

  const initialFormState = {
    date: new Date().toISOString().split('T')[0],
    partyName: '',
    companyName: '',
    mobileNumber: '',
    whatsappNumber: '',
    address: '',
    email: ''
  };

  useEffect(() => {
    loadParties();
  }, []);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredParties(parties);
    } else {
      const filtered = parties.filter(party =>
        party.partyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (party.companyName && party.companyName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        party.mobileNumber.includes(searchTerm) ||
        (party.whatsappNumber && party.whatsappNumber.includes(searchTerm))
      );
      setFilteredParties(filtered);
    }
    // Reset mobile page when search term changes
    setMobilePage(1);
  }, [searchTerm, parties]);

  const loadParties = async () => {
    setLoading(true);
    const data = await getParties();
    if (data) {
      setParties(data);
      setFilteredParties(data);
    }
    setLoading(false);
  };

  const resetForm = () => {
    form.resetFields();
    setEditingParty(null);
  };

  const openModal = (party = null) => {
    if (party) {
      setEditingParty(party);
      const editData = {
        date: party.date,
        partyName: party.partyName,
        companyName: party.companyName || '',
        mobileNumber: party.mobileNumber,
        whatsappNumber: party.whatsappNumber || '',
        address: party.address || '',
        email: party.email || ''
      };
      form.setFieldsValue(editData);
    } else {
      form.setFieldsValue(initialFormState);
    }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    resetForm();
  };

  const handleEdit = (party) => {
    openModal(party);
  };

  const handleDelete = async (id, partyName) => {
    setLoading(true);
    const success = await deleteParty(id);
    if (success) {
      message.success(`${partyName} deleted successfully`);
      await loadParties();
    }
    setLoading(false);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const mobileExists = parties.some(
        party =>
          party.mobileNumber === values.mobileNumber &&
          (!editingParty || party.id !== editingParty.id)
      );

      if (mobileExists) {
        message.error('This Mobile Number already exists!');
        return;
      }
      setLoading(true);

      let result;
      if (editingParty) {
        result = await updateParty(editingParty.id, values);
        if (result) message.success('Party updated successfully');
      } else {
        result = await createParty(values);
        if (result) message.success('Party created successfully');
      }

      if (result) {
        resetForm();
        await loadParties();
        closeModal();
      }

      setLoading(false);
    } catch (error) {
      console.log('Validation failed:', error);
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Mobile pagination handler
  const handleMobilePageChange = (page) => {
    setMobilePage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Get paginated parties for mobile view
  const paginatedParties = filteredParties.slice(
    (mobilePage - 1) * mobilePageSize,
    mobilePage * mobilePageSize
  );

  // Custom row className for alternate colors (desktop table)
  const getRowClassName = (_, index) => {
    return index % 2 === 0 ? 'even-row' : 'odd-row';
  };

  // Desktop columns (unchanged)
  const columns = [
    {
      title: 'SR NO.',
      key: 'srno',
      width: 70,
      fixed: 'left',
      align: 'center',
      render: (_, __, index) => (
        <Text style={{ fontWeight: 500, color: token.colorPrimary }}>
          {index + 1}
        </Text>
      )
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width: 110,
      render: (date) => (
        <Space size={4}>
          <CalendarOutlined style={{ fontSize: 12, color: token.colorTextSecondary }} />
          <Text style={{ fontSize: 13 }}>{date}</Text>
        </Space>
      )
    },
    {
      title: 'Party Name',
      dataIndex: 'partyName',
      key: 'partyName',
      width: 160,
      ellipsis: true,
      render: (text) => (
        <Space size={6}>
          <UserOutlined style={{ color: token.colorPrimary, fontSize: 13 }} />
          <Text strong style={{ fontSize: 13 }}>
            {text}
          </Text>
        </Space>
      )
    },
    {
      title: 'Company',
      dataIndex: 'companyName',
      key: 'companyName',
      width: 150,
      ellipsis: true,
      render: (text) => text ? (
        <Space size={4}>
          <ApartmentOutlined style={{ fontSize: 12, color: token.colorTextSecondary }} />
          <Text style={{ fontSize: 13 }}>{text}</Text>
        </Space>
      ) : <Text type="secondary" style={{ fontSize: 12 }}>—</Text>
    },
    {
      title: 'Mobile',
      dataIndex: 'mobileNumber',
      key: 'mobileNumber',
      width: 130,
      render: (text) => (
        <Space size={4}>
          <PhoneOutlined style={{ color: token.colorSuccess, fontSize: 12 }} />
          <Text style={{ fontSize: 13 }}>{text}</Text>
        </Space>
      )
    },
    {
      title: 'WhatsApp',
      dataIndex: 'whatsappNumber',
      key: 'whatsappNumber',
      width: 130,
      render: (text) => text ? (
        <Space size={4}>
          <WhatsAppOutlined style={{ color: '#25D366', fontSize: 13 }} />
          <Text style={{ fontSize: 13 }}>{text}</Text>
        </Space>
      ) : <Text type="secondary" style={{ fontSize: 12 }}>—</Text>
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 180,
      ellipsis: true,
      render: (text) => text ? (
        <Space size={4}>
          <MailOutlined style={{ fontSize: 12, color: token.colorWarning }} />
          <Text style={{ fontSize: 13 }}>{text}</Text>
        </Space>
      ) : <Text type="secondary" style={{ fontSize: 12 }}>—</Text>
    },
    {
      title: 'Created',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 110,
      render: (date) => (
        <Space size={4}>
          <ClockCircleOutlined style={{ fontSize: 12, color: token.colorTextSecondary }} />
          <Text style={{ fontSize: 13 }}>
            {date ? new Date(date).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '-'}
          </Text>
        </Space>
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 100,
      fixed: 'right',
      align: 'center',
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="Edit">
            <Button
              type="text"
              size="small"
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
              style={{ color: token.colorPrimary }}
            />
          </Tooltip>
          <Popconfirm
            title="Delete Party"
            description={`Delete ${record.partyName}?`}
            onConfirm={() => handleDelete(record.id, record.partyName)}
            okText="Yes"
            cancelText="No"
            placement="topRight"
          >
            <Tooltip title="Delete">
              <Button
                type="text"
                size="small"
                danger
                icon={<DeleteOutlined />}
              />
            </Tooltip>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div style={{ minHeight: '100vh', background: token.colorBgContainer, padding: isMobile ? 12 : 0 }}>
      {/* Header Bar - Responsive */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
        flexWrap: 'wrap',
        gap: 12,
        padding: isMobile ? '0 4px' : 0
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <Title level={isMobile ? 5 : 4} style={{ margin: 0, fontWeight: 500 }}>
            Party Ledger
          </Title>
          <Text type="secondary" style={{ fontSize: 13 }}>
            {filteredParties.length} parties
          </Text>
        </div>

        <Space size="middle" wrap>
          <Input
            placeholder={isMobile ? "Search..." : "Search by name, company, mobile or whatsapp..."}
            prefix={<SearchOutlined style={{ color: token.colorTextSecondary }} />}
            onChange={handleSearch}
            style={{ width: isMobile ? '100%' : 320 }}
            allowClear
            size="middle"
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => openModal()}
          >
            Add Party
          </Button>
        </Space>
      </div>

      {/* Responsive Content: Table for Desktop, Collapse Cards for Mobile */}
      {isMobile ? (
        // Mobile View: Expandable Cards
        <div>
          {paginatedParties.length === 0 ? (
            <Card style={{ textAlign: 'center', marginTop: 24 }}>
              <Text type="secondary">No parties found</Text>
            </Card>
          ) : (
            <>
              <Collapse
                accordion={false}
                expandIcon={({ isActive }) => <RightOutlined rotate={isActive ? 90 : 0} />}
                expandIconPosition="end"
                style={{ background: 'transparent', border: 'none' }}
              >
                {paginatedParties.map((party, idx) => (
                  <Panel
                    key={party.id}
                    header={
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: 8 }}>
                        <div style={{ flex: 1 }}>
                          <Text strong style={{ fontSize: 15 }}>{party.partyName}</Text>
                          {party.companyName && (
                            <div><Text type="secondary" style={{ fontSize: 12 }}>{party.companyName}</Text></div>
                          )}
                        </div>
                        <Space direction="vertical" size={0} align="end">
                          <Space size={4}>
                            <PhoneOutlined style={{ color: token.colorSuccess, fontSize: 12 }} />
                            <Text style={{ fontSize: 13 }}>{party.mobileNumber}</Text>
                          </Space>
                          <Text type="secondary" style={{ fontSize: 11 }}>{party.date}</Text>
                        </Space>
                      </div>
                    }
                    style={{
                      marginBottom: 12,
                      background: '#fff',
                      borderRadius: 8,
                      border: `1px solid ${token.colorBorderSecondary}`,
                      overflow: 'hidden'
                    }}
                  >
                    <div style={{ padding: '4px 0' }}>
                      <Row gutter={[8, 12]}>
                        {party.whatsappNumber && (
                          <Col span={24}>
                            <Space>
                              <WhatsAppOutlined style={{ color: '#25D366' }} />
                              <Text>WhatsApp: {party.whatsappNumber}</Text>
                            </Space>
                          </Col>
                        )}
                        {party.email && (
                          <Col span={24}>
                            <Space>
                              <MailOutlined style={{ color: token.colorWarning }} />
                              <Text>Email: {party.email}</Text>
                            </Space>
                          </Col>
                        )}
                        {party.address && (
                          <Col span={24}>
                            <Space>
                              <ApartmentOutlined style={{ color: token.colorTextSecondary }} />
                              <Text>Address: {party.address}</Text>
                            </Space>
                          </Col>
                        )}
                        <Col span={24}>
                          <Space>
                            <ClockCircleOutlined style={{ color: token.colorTextSecondary }} />
                            <Text>Created: {party.created_at ? new Date(party.created_at).toLocaleDateString('en-IN') : '-'}</Text>
                          </Space>
                        </Col>
                      </Row>
                      <Divider style={{ margin: '12px 0 8px' }} />
                      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                        <Button
                          type="link"
                          icon={<EditOutlined />}
                          onClick={() => handleEdit(party)}
                          size="small"
                        >
                          Edit
                        </Button>
                        <Popconfirm
                          title="Delete Party"
                          description={`Delete ${party.partyName}?`}
                          onConfirm={() => handleDelete(party.id, party.partyName)}
                          okText="Yes"
                          cancelText="No"
                          placement="top"
                        >
                          <Button
                            type="link"
                            danger
                            icon={<DeleteOutlined />}
                            size="small"
                          >
                            Delete
                          </Button>
                        </Popconfirm>
                      </div>
                    </div>
                  </Panel>
                ))}
              </Collapse>

              {/* Pagination for Mobile */}
              {filteredParties.length > mobilePageSize && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                  <Pagination
                    current={mobilePage}
                    pageSize={mobilePageSize}
                    total={filteredParties.length}
                    onChange={handleMobilePageChange}
                    size="small"
                    showSizeChanger={false}
                    showTotal={(total) => `${total} parties`}
                  />
                </div>
              )}
            </>
          )}
        </div>
      ) : (
        // Desktop Table View (unchanged)
        <Table
          columns={columns}
          dataSource={filteredParties}
          rowKey="id"
          loading={loading}
          size="middle"
          rowClassName={getRowClassName}
          pagination={{
            pageSize: 10,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
            showSizeChanger: true,
            showQuickJumper: true,
            size: 'default'
          }}
          scroll={{ x: 'max-content' }}
          style={{
            borderRadius: 8,
            overflow: 'hidden',
            border: `1px solid ${token.colorBorderSecondary}`
          }}
        />
      )}

      {/* Modal - unchanged */}
      <Modal
        title={
          <Space>
            {editingParty ? <EditOutlined /> : <PlusOutlined />}
            <span>{editingParty ? 'Edit Party' : 'Add New Party'}</span>
          </Space>
        }
        open={isModalOpen}
        onCancel={closeModal}
        width={560}
        footer={[
          <Button key="cancel" onClick={closeModal}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleSubmit}
          >
            {editingParty ? 'Update' : 'Save'}
          </Button>
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={initialFormState}
          size="middle"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="date"
                label="Date"
                rules={[{ required: true, message: 'Required' }]}
              >
                <Input type="date" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="partyName"
                label="Party Name"
                rules={[{ required: true, message: 'Required' }]}
              >
                <Input placeholder="Enter party name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="companyName"
                label="Company Name"
              >
                <Input placeholder="Enter company name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="mobileNumber"
                label="Mobile Number"
                rules={[
                  { required: true, message: 'Mobile Number Required' },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: 'Enter valid 10 digit mobile number'
                  }
                ]}
              >
                <Input
                  placeholder="Enter mobile number"
                  maxLength={10}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, '');
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="whatsappNumber"
                label="WhatsApp Number"
                rules={[
                  {
                    pattern: /^[0-9]{10}$/,
                    message: 'Enter valid 10 digit WhatsApp number'
                  }
                ]}
              >
                <Input
                  placeholder="Enter WhatsApp number"
                  maxLength={10}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, '');
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ type: 'email', message: 'Invalid email' }]}
              >
                <Input placeholder="Enter email address" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="address"
                label="Address"
              >
                <TextArea rows={2} placeholder="Enter address" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/* Global styles for table row striping */}
      <style jsx>{`
        :global(.compact-table-row td) {
          padding: 10px 12px !important;
          line-height: 1.4 !important;
        }
        :global(.compact-table-row .ant-table-cell) {
          white-space: nowrap !important;
        }
        :global(.ant-table-thead > tr > th) {
          padding: 12px 12px !important;
          background: ${token.colorBgLayout};
          font-weight: 500;
          font-size: 13px;
        }
        :global(.even-row) {
          background-color: #ffffff !important;
        }
        :global(.odd-row) {
          background-color: #f5f5f5 !important;
        }
        :global(.even-row .ant-table-cell-fix-left),
        :global(.even-row .ant-table-cell-fix-right) {
          background-color: #ffffff !important;
        }
        :global(.odd-row .ant-table-cell-fix-left),
        :global(.odd-row .ant-table-cell-fix-right) {
          background-color: #f5f5f5 !important;
        }
        :global(.ant-table-thead .ant-table-cell-fix-left),
        :global(.ant-table-thead .ant-table-cell-fix-right) {
          background: ${token.colorBgLayout} !important;
        }
        :global(.even-row:hover),
        :global(.odd-row:hover) {
          background-color: #e6f7ff !important;
        }
        :global(.even-row:hover .ant-table-cell-fix-left),
        :global(.even-row:hover .ant-table-cell-fix-right),
        :global(.odd-row:hover .ant-table-cell-fix-left),
        :global(.odd-row:hover .ant-table-cell-fix-right) {
          background-color: #e6f7ff !important;
        }
      `}</style>
    </div>
  );
};

export default PartyManagement;